import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from '../../utils/helpers'
import { VUE_APP_BASE_API_URL }  from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    image: {},
    images: {},
    broadcastImages: {},
    primaryImages: {
      primaryPortrait: null,
      primaryLandscape: null
    }
  }
})
  .get({
    action: 'getImage',
    property: 'image',
    path: ({ id }) => `/images/${id}`,
    onSuccess: payloadToState('image')
  })
    .get({
      action: 'getImages',
      property: 'images',
      queryParams: true,
      path: `/images/`,
      onSuccess: payloadToState('images')
    })
    .get({
      action: 'getBroadcastImages',
      property: 'images',
      queryParams: true,
      path: `/broadcast-images/`,
      onSuccess: payloadToState('broadcastImages')
    })
  .get({
    action: 'getPrimaryImages',
    property: 'images',
    queryParams: true,
    path: `/primary-images/`,
    onSuccess: payloadToState('primaryImages')
  })
  .post({
    action: 'createImage',
    property: 'image',
    path: '/images/',
    onSuccess: payloadToState('images')
  })
    .put({
      action: 'updateImage',
      property: 'image',
      queryParams: true,
      path: `/images/`
    })
    .put({
      action: 'copyBroadcastImageToShow',
      property: 'image',
      queryParams: true,
      path: `/broadcast-images/`
    })
  .delete({
    action: 'deleteImage',
    property: 'image',
    path: '/images/',
    queryParams: true,
    beforeRequest: getOptimisticDelete('images'),
    onSuccess: payloadToState('image')
  })
  .getStore()
